import { Link } from "react-router-dom";
import type { Plot } from "@/types/content";
import { formatDateCn } from "@/lib/content";

interface PlotCardProps {
  item: Plot;
}

export default function PlotCard({ item }: PlotCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} 剧情解析配图`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-[11px] px-2 py-0.5 rounded-md flex items-center gap-1">
          <i className="ri-lightbulb-line" />
          解析
        </span>
      </div>
      <div className="p-4 flex flex-col flex-1">
        <h3 className="font-heading font-bold text-base text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
          {item.title}
        </h3>
        <p className="text-sm text-foreground-500 mt-2 leading-relaxed line-clamp-2 flex-1">
          {item.summary}
        </p>
        <div className="flex items-center gap-2 mt-3 flex-wrap">
          {item.tags.map((tag) => (
            <span key={tag} className="bg-secondary-100 text-secondary-900 text-[11px] px-2 py-0.5 rounded-md">
              {tag}
            </span>
          ))}
        </div>
        <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-film-line" />
            {item.workTitle}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" />
            {formatDateCn(item.date)}
          </span>
        </div>
      </div>
    </Link>
  );
}